<nav class="navbar">
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="editIntervenantRequests$.next(null)">Ajouter un intervenant</button>
	</div>
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="exportRequests$.next()">Exporter</button>
	</div>
</nav>

<div class="mat-elevation-z8">
	<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
	<table mat-table matSort [dataSource]="dataSource">
		<ng-container matColumnDef="id">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
			<td mat-cell *matCellDef="let data"> {{ data.entity.id }} </td>
		</ng-container>

		<ng-container matColumnDef="nom">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Nom </th>
			<td mat-cell *matCellDef="let data"> {{ data.entity.nom }} </td>
		</ng-container>

		<ng-container matColumnDef="prenom">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Pr&eacute;nom </th>
			<td mat-cell *matCellDef="let data"> {{ data.entity.prenom }} </td>
		</ng-container>

		<ng-container matColumnDef="cadreEmploi">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Cadre Emploi </th>
			<td mat-cell *matCellDef="let data"> {{ data.entity.cadreEmploi }} </td>
		</ng-container>

		<ng-container matColumnDef="nomEntreprise">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Entreprise </th>
			<td mat-cell *matCellDef="let data"> {{ data.nomEntreprise }} </td>
		</ng-container>

		<ng-container matColumnDef="telephone">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> T&eacute;l&eacute;phone </th>
			<td mat-cell *matCellDef="let data"> {{ data.entity.indicatifTelephone }}&nbsp;{{ data.entity.telephone }} </td>
		</ng-container>

		<ng-container matColumnDef="email">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> E-mail </th>
			<td mat-cell *matCellDef="let data"> {{ data.entity.email }} </td>
		</ng-container>

		<ng-container matColumnDef="interne">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Interne </th>
			<td mat-cell *matCellDef="let data"> {{ data.entity.interne ? 'Oui' : 'Non' }} </td>
		</ng-container>

		<ng-container matColumnDef="travailleurDetache">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Travailleur d&eacute;tach&eacute; </th>
			<td mat-cell *matCellDef="let data"> {{ data.entity.travailleurDetache ? 'Oui' : 'Non' }} </td>
		</ng-container>

		<ng-container matColumnDef="obsolete">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Actif </th>
			<td mat-cell *matCellDef="let data"> {{ data.entity.obsolete ? 'Non' : 'Oui' }} </td>
		</ng-container>
	
		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef>&nbsp;</th>
			<td mat-cell *matCellDef="let data">
				<div class="actionButtons">
					<button type="button" (click)="editIntervenantRequests$.next(data.entity)" class="btn btn-primary">Modifier</button>
					<button type="button" (click)="delete(data.entity)" class="btn btn-danger">Supprimer</button>
				</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
	</table>
	<mat-paginator #paginator showFirstLastButtons [pageSizeOptions]="[5, 10, 20, 50]" 
		[pageSize]="10" aria-label="Choisissez une page">
	</mat-paginator>
</div>

<nav class="navbar footer">
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="editIntervenantRequests$.next(null)">Ajouter un intervenant</button>
	</div>
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="exportRequests$.next()">Exporter</button>
	</div>
</nav>

<edit-intervenant
	[openRequests]="editIntervenantRequests$"
	(intervenantCreated)="this.reloadIntervenants$.next()"
	(intervenantUpdated)="this.reloadIntervenants$.next()">
</edit-intervenant>